import { useState, useEffect } from 'react'

export default function LastUpdated({ data }) {
  const ts = computeLastUpdated(data)
  if (!ts) return null
  
  const fmt = formatRelative(ts)
  
  return (
    <span className="last-updated" title={new Date(ts).toLocaleString()}>
      🕐 {fmt}
    </span>
  )
}

function computeLastUpdated(data) {
  if (!data) return null
  const items = Array.isArray(data) ? data : [data]
  let max = 0
  for (const item of items) {
    if (item.updatedAt) {
      const t = new Date(item.updatedAt).getTime()
      if (t > max) max = t
    } else if (item._ts) {
      const t = item._ts * 1000
      if (t > max) max = t
    }
    if (typeof item === 'object') {
      for (const val of Object.values(item)) {
        if (val && typeof val === 'object' && !Array.isArray(val)) {
          if (val.updatedAt) {
            const t = new Date(val.updatedAt).getTime()
            if (t > max) max = t
          }
        }
        if (Array.isArray(val)) {
          for (const sub of val) {
            if (sub?.updatedAt) {
              const t = new Date(sub.updatedAt).getTime()
              if (t > max) max = t
            }
          }
        }
      }
    }
  }
  return max || null
}

function formatRelative(ts) {
  const diff = Date.now() - ts
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'Just now'
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}d ago`
  return new Date(ts).toLocaleDateString()
}
